import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { PATIENT_PORTAL_IMAGES } from './patientPortalImagery';
import { DELETE_ACCOUNT_PATH } from '@/constants/patientPortalContact';

const navItems = [
  { to: '/patient-loyalty', label: 'Home', end: true },
  { to: '/patient-loyalty/loyalty', label: 'Points' },
  { to: '/patient-loyalty/records', label: 'Records' },
  { to: '/patient-loyalty/booking', label: 'Book' },
  { to: '/patient-loyalty/wallet', label: 'Wallet' },
  { to: '/patient-loyalty/family', label: 'Family' },
  { to: '/patient-loyalty/referrals', label: 'Referrals' },
  { to: '/patient-loyalty/challenges', label: 'Challenges' },
  { to: '/patient-loyalty/notifications', label: 'Inbox' },
  { to: '/patient-loyalty/contact', label: 'Contact' },
];

export default function PatientPortalLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (to: string, end?: boolean) => {
    if (end) return location.pathname === to || location.pathname === `${to}/`;
    return location.pathname.startsWith(to);
  };

  const signOut = () => {
    localStorage.removeItem('patient_token');
    navigate('/patient-loyalty/login');
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.35]"
        style={{
          backgroundImage: `url(${PATIENT_PORTAL_IMAGES.home})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          filter: 'blur(40px) saturate(1.1)',
        }}
        aria-hidden
      />
      <div className="pointer-events-none fixed inset-0 bg-gradient-to-b from-white/80 via-slate-50/90 to-slate-100/95" aria-hidden />

      <header className="sticky top-0 z-20 border-b border-white/10 bg-gradient-to-r from-slate-950 via-teal-950 to-cyan-950 text-white shadow-lg backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-4 py-3">
          <nav className="flex items-center gap-1 overflow-x-auto pb-0.5 -mx-1 px-1 scrollbar-none">
            {navItems.map(({ to, label, end }) => (
              <Link
                key={to}
                to={to}
                className={`shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition ${
                  isActive(to, end)
                    ? 'bg-white text-teal-900 shadow-sm'
                    : 'text-teal-100/90 hover:bg-white/10 hover:text-white'
                }`}
              >
                {label}
              </Link>
            ))}
            <button
              type="button"
              className="shrink-0 rounded-full px-3 py-1.5 text-xs font-medium text-teal-100/90 hover:bg-white/10 hover:text-white transition ml-0.5"
              onClick={signOut}
            >
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className="relative max-w-3xl mx-auto px-4 py-8 sm:px-6">
        <Outlet />
      </main>
      <footer className="relative max-w-3xl mx-auto px-4 pb-8 text-center text-xs text-slate-500 space-y-1">
        <p>
          <Link to="/patient-loyalty/contact" className="text-teal-800/90 hover:underline font-medium">
            Contact us
          </Link>
          <span className="mx-2 text-slate-300">·</span>
          <Link to={DELETE_ACCOUNT_PATH} className="text-teal-800/90 hover:underline font-medium">
            Delete app account
          </Link>
        </p>
        <p className="text-slate-400">TrueCare patient portal · True Hospitals</p>
      </footer>
    </div>
  );
}
